<div class="modal-header">
  <h2 class="modal-title" id="v2-briefing-access-title">
    @if (signedOut) {
      Not available without an account
    } @else {
      Not included in your account
    }
  </h2>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    data-testid="access-close"
    (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <p class="bf-access-lead">
    @if (signedOut) {
      These sections need an account, and this browser is not signed into
      one. Nothing is wrong with the airport record — the parts below are
      simply not part of what a browsing session covers.
    } @else {
      You are signed in, but briefing detail is a separate entitlement and
      this account does not carry it yet. Nothing is wrong with the airport
      record — the parts below are simply not part of what the account
      covers.
    }
  </p>

  <div class="bf-access-lists">
    <div class="bf-access-list">
      <p class="eyebrow">Open to you</p>
      <ul data-testid="access-open">
        @for (section of openSections; track section) {
          <li>{{ section }}</li>
        }
      </ul>
    </div>

    <div class="bf-access-list">
      <p class="eyebrow">Needs briefing access</p>
      <ul data-testid="access-gated">
        @for (section of gatedSections; track section) {
          <li>
            <ng-icon name="lucideLock" class="bf-access-lock" aria-hidden="true" />
            {{ section }}
          </li>
        }
      </ul>
    </div>
  </div>

  <p class="bf-access-foot">
    @if (signedOut) {
      The briefing PDF needs it too. Sign in if you already have access, or
      ask the trip desk to set an account up — say which airports you plan.
    } @else {
      The briefing PDF needs it too. The trip desk grants it — say which
      airports you plan and they can add it to this account.
    }
  </p>
</div>

<div class="modal-footer">
  <button type="button" class="evo-btn" data-testid="access-dismiss" (click)="activeModal.close()">
    Not now
  </button>
  @if (signedOut) {
    <a class="evo-btn" data-testid="access-signin" [href]="loginHref">
      Sign in
    </a>
    <a class="evo-btn evo-btn--primary" data-testid="access-desk" [href]="deskHref">
      Request an account
    </a>
  } @else {
    <a class="evo-btn evo-btn--primary" data-testid="access-desk" [href]="deskHref">
      Ask the trip desk
    </a>
  }
</div>
